module.exports = __webpack_public_path__ + "static/media/ShoppiesLogo.7a32f008.png";